import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export function getOttopilotWorkspacePath(workspaceId: Uuid, relativePath = ""): string {
    const normalizedPath = relativePath.replace(/^\/+/, "");
    const basePath = `/w/${workspaceId}/ottopilot`;

    return normalizedPath === "" ? basePath : `${basePath}/${normalizedPath}`;
}

export function getOttopilotWorkspaceRoutePattern(relativePathPattern = ""): RegExp {
    const normalizedPattern = relativePathPattern.replace(/^\/+/, "");
    const suffix = normalizedPattern === "" ? "" : `/${normalizedPattern}`;

    return new RegExp(String.raw`^\/w\/[a-zA-Z0-9_-]+\/ottopilot${suffix}(\/.*)?$`);
}

export function normalizeOttopilotWorkspaceHref(workspaceId: Uuid, href: string): string {
    if (href.startsWith(`/w/${workspaceId}/ottopilot`)) {
        return href;
    }

    if (href.startsWith(`/w/${workspaceId}/`)) {
        return getOttopilotWorkspacePath(workspaceId, href.slice(`/w/${workspaceId}/`.length));
    }

    return href;
}
